/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LoadunitType = 'NotSpecified' | 'PlanningUnit' | 'PhysicalUnit' | 'ExternalUnit' | 'ForTourPlanning';

export const LoadunitType = {
    NotSpecified: 'NotSpecified' as LoadunitType,
    PlanningUnit: 'PlanningUnit' as LoadunitType,
    PhysicalUnit: 'PhysicalUnit' as LoadunitType,
    ExternalUnit: 'ExternalUnit' as LoadunitType,
    ForTourPlanning: 'ForTourPlanning' as LoadunitType
};

